import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    standalone: true,
    imports: [NgStyle],
    selector: 'progress-bar',
    templateUrl: './progress-bar.html',
    styleUrls: ['./progress-bar.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressBarComponent {
    @Input({ required: true })
    maxValue = 100;

    @Input({ required: true })
    currentValue = 0;

    protected get progressPercentage(): number {
        return (this.currentValue / this.maxValue) * 100;
    }
}
